import { isNullOrUndefined } from 'util';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { HttperrorhandlerService } from 'src/app/main/shared/http/httperrorhandler.service';
import { catchError } from 'rxjs/operators';
import { ConstantsModule } from '../../shared/constants/constants.module';

@Injectable({
  providedIn: 'root'
})
export class ObservedWeatherDataService {

  serviceURL = 'http://40.118.204.142/tomcat/geoserver/NEWRM/ows';
  gisStoreName = 'NEWRM';

  constructor(
    private http: HttpClient,
    private errorHandler: HttperrorhandlerService,
    private constants: ConstantsModule
  ) { }

  getSourceListForComponent(options): Observable<any> {
    if (isNullOrUndefined(options['component'])) {
      return;
    }
    return this.http.post<any>(environment.url.PLAY_URL + 'comm/getrankwisesource', options).pipe(
      catchError(this.errorHandler.handleError('All Sources data for Components : ', []))
    );
  }

  getDateRangeForComponent(component: string, source: string): Observable<any> {

    return this.http.get<any>(environment.url.PLAY_URL + 'comm/range2/' + component + '/' + source).pipe(
      catchError(this.errorHandler.handleError('Date range request for ' + component, []))
    );
  }

  getHeirarchy(options: object): Observable<any> {
    const heatMapUrl = 'locations/heirarchy';
    return this.http.post<any>(environment.url.PLAY_URL + heatMapUrl, options).pipe(
      catchError(this.errorHandler.handleError('Rainfall linechart data request', []))
    );
  }

  getLocationLevelForSourceAndComponent(options: object): Observable<any> {
    return this.http.post<any>(environment.url.PLAY_URL + 'comm/getLocTypes', options).pipe(
      catchError(this.errorHandler.handleError('Locations Level for Source Data request', []))
    );
  }

  getHeatMapData(url, options: object): Observable<any> {
    const heatMapUrl = url;
    return this.http.post<any>(heatMapUrl, options).pipe(
      catchError(this.errorHandler.handleError('error in Heatmap data request', []))
    );
  }

  getGeoJsonLayerData(layerName: string, filter): Observable<any> {
    let layerURL = this.serviceURL + '?service=WFS&version=1.0.0&request=GetFeature&typeName=' + this.gisStoreName + ':' + layerName + '&maxFeatures=5000000&outputFormat=application%2Fjson' as string;
    if (filter || filter == '')
      layerURL += '&cql_filter=' + filter;
    return this.http.get(layerURL).pipe(
      catchError(this.errorHandler.handleError('error in GeoJson data request', []))
    );
  }

  getdataGis(url, options: object, homeReservoir = false): Observable<any> {
    return this.http.post<any>(environment.url.PLAY_URL + url, options).pipe(
      catchError(this.errorHandler.handleError('table data request', []))
    );
  }

  fetchSource(countryUUID:any, stateUUID:any): Observable<any> {
    const heatMapUrl = 'rf/getSourcesForState/' + countryUUID + '/' + stateUUID;
    return this.http.get<any>(environment.url.OBSERVED_API_URL + heatMapUrl).pipe(
      catchError(this.errorHandler.handleError('Source Requested', []))
    );
  }

  formatdata(layer, geodata, data) {

    const component = layer.Component;
    const src = layer.SRC;
    let formatedData;
    // console.log("formatdata ::",component,src,geodata, data);
    if (component == this.constants.COMPONENT.RAINFALL)
      formatedData = this.formatRFData(geodata, data);

    return formatedData;
  }

  formatRFData(geodata, data) {
    geodata['features'].forEach(station => {

      data.forEach(element => {
        if (station['properties']['loc_uuid'] == element['uuid'])
          Object.assign(station['properties'], { 'actual': element['actual'] })
      });
    });
    return geodata;
  }

}
